import { render, staticRenderFns } from "./studentAndClassTypeList.vue?vue&type=template&id=062691be&scoped=true&"
import script from "./studentAndClassTypeList.vue?vue&type=script&lang=js&"
export * from "./studentAndClassTypeList.vue?vue&type=script&lang=js&"
import style0 from "./studentAndClassTypeList.vue?vue&type=style&index=0&id=062691be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062691be",
  null
  
)

export default component.exports